import { useTranslation, Trans } from "react-i18next";

import s1 from '../../img/Home/s1.png';
import s2 from '../../img/Home/s2.png';

import i1 from '../../img/Home/i1.svg';
import i2 from '../../img/Home/i2.svg';
import i3 from '../../img/Home/i3.svg';
import i4 from '../../img/Home/i4.svg';

function SafetyFunds () {

    const { t } = useTranslation();
      
    return(
        <div className="overflow-hidden relative mt-[100px] xl:mt-[140px]">
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto">
                <div className="flex flex-col xl:flex-row justify-between gap-[20px] xl:items-center">
                    <p className="text-[24px] xl:text-[48px] manrope leading-[1.2] font-[500]">{t('home.24')}</p>
                    <p className="text-[#000000B2] roboto font-[300] text-[12px] xl:text-[14px] xl:max-w-[600px]">{t('home.25')}</p>
                </div>
                <div className="mt-[40px] xl:mt-[60px]">
                    <div className="flex flex-col xl:flex-row gap-[12px] xl:gap-[20px] xl:h-[280px]">
                        <div className="relative flex-shrink-0">
                            <img src={s1} alt="" className="h-[156px] w-full xl:h-auto object-cover rounded-[20px]"/>
                            <p className="absolute bottom-[30px] xl:bottom-[40px] left-[20px] xl:left-[30px] text-white manrope text-[16px] xl:text-[20px] font-[500]">{t('home.26')}</p>
                        </div>
                        <div className="bg-[#131313] rounded-[20px] w-full h-[156px] xl:h-auto relative">
                            <img src={i1} className="w-[40px] h-[40px] xl:w-[60px] xl:h-[60px] mt-[20px] mx-[20px] xl:mx-[40px]" alt="" />\
                            <p className="absolute bottom-[30px] xl:bottom-[40px] left-[20px] xl:left-[40px] text-white manrope text-[16px] xl:text-[20px] font-[500]">{t('home.27')}</p>
                        </div>
                        <div className="bg-[#131313] rounded-[20px] w-full h-[156px] xl:h-auto relative">
                            <img src={i2} className="w-[40px] h-[40px] xl:w-[60px] xl:h-[60px] mt-[20px] mx-[20px] xl:mx-[40px]" alt="" />\
                            <p className="absolute bottom-[30px] xl:bottom-[40px] left-[20px] xl:left-[40px] text-white manrope text-[16px] xl:text-[20px] font-[500]">{t('home.28')}</p>
                        </div>
                    </div>
                    <div className="flex flex-col xl:flex-row gap-[12px] xl:gap-[20px] xl:h-[280px] mt-[12px] xl:mt-[20px]">    
                        <div className="bg-[#131313] rounded-[20px] w-full h-[156px] xl:h-auto relative">
                            <img src={i3} className="w-[40px] h-[40px] xl:w-[60px] xl:h-[60px] mt-[20px] mx-[20px] xl:mx-[40px]" alt="" />\
                            <p className="absolute bottom-[30px] xl:bottom-[40px] left-[20px] xl:left-[40px] text-white manrope text-[16px] xl:text-[20px] font-[500]">{t('home.29')}</p>
                        </div>
                        <div className="bg-[#131313] rounded-[20px] w-full h-[156px] xl:h-auto relative">
                            <img src={i4} className="w-[40px] h-[40px] xl:w-[60px] xl:h-[60px] mt-[20px] mx-[20px] xl:mx-[40px]" alt="" />\
                            <p className="absolute bottom-[30px] xl:bottom-[40px] left-[20px] xl:left-[40px] text-white manrope text-[16px] xl:text-[20px] font-[500]">{t('home.30')}</p>
                        </div>
                        <div className="relative flex-shrink-0">
                            <img src={s2} alt="" className="h-[156px] w-full xl:h-auto object-cover rounded-[20px]"/>
                            <p className="absolute bottom-[30px] xl:bottom-[40px] left-[20px] xl:left-[30px] text-white manrope text-[16px] xl:text-[20px] font-[500]">{t('home.31')}</p>
                        </div>
                    </div>
                </div>   
            </div>
        </div>
    );
}

export default SafetyFunds;